<!-- Cấu trúc / class / style khớp web-hrm sidebar.component.html (không dùng ng-icon) -->
<div class="flex flex-col h-full min-h-0 w-full">
  <div
    class="h-16 flex items-center justify-between px-2"
  >
    <a
      *ngIf="sidebarExpanded"
      routerLink="/home"
      class="cursor-pointer"
      title="Home"
    >
      <img
        [src]="logoUrl"
        alt="UniHRM Logo"
        class="h-8"
        loading="lazy"
      />
    </a>
    <button
      type="button"
      class="shell-sidebar-toggle p-2 -m-2 text-muted-foreground hover:bg-secondary rounded-full transition-colors"
      (click)="onToggleClick()"
      [attr.aria-label]="sidebarExpanded ? 'Thu gọn menu' : 'Mở rộng menu'"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-[18px] h-[18px] transition-transform duration-300"
        [class.rotate-180]="sidebarExpanded"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>

  <nav
    class="flex-1 px-3 flex flex-col gap-1 overflow-y-auto py-0 min-h-0"
    *ngIf="mainNavItems.length || footerNavItems.length"
  >
    <ng-container *ngFor="let menuItem of mainNavItems; let i = index">
      <ng-container
        *ngIf="
          apiClassString(menuItem.classs) !== 'navigation-header' ||
          isParent(menuItem)
        "
      >
        <button
          *ngIf="isLeaf(menuItem)"
          type="button"
          class="sidebar-shell-nav-btn flex items-center w-full py-2.5 transition-colors group border-0 cursor-pointer text-left"
          [ngClass]="sidebarNavButtonNgClass(menuItem, 'leaf')"
          [style.border-radius]="'var(--sidebar-nav-radius)'"
          [style.background-color]="navLeafRowBg(menuItem)"
          (click)="navigateToItem(menuItem)"
          [title]="!sidebarExpanded ? menuItem.label : undefined"
        >
          <!-- <i
            *ngIf="apiClassString(menuItem.icon)"
            class="shrink-0 w-[20px] h-[20px] text-[1.25rem] leading-5 flex items-center justify-center"
            [ngClass]="apiClassString(menuItem.icon)"
            [style.color]="
              isLeafActive(menuItem) ? 'var(--primary)' : 'var(--foreground)'
            "
            [style.opacity]="isLeafActive(menuItem) ? '1' : '0.6'"
          ></i> -->
          <span
          class="!font-[500]"
            *ngIf="sidebarExpanded"
            [style.font-size]="'var(--text-sm)'"
            >{{ menuItem.label }}</span
          >
        </button>

        <div *ngIf="isParent(menuItem)">
          <button
            type="button"
            class="sidebar-shell-nav-btn flex items-center w-full py-2.5 transition-colors border-0 cursor-pointer text-left"
            [ngClass]="sidebarNavButtonNgClass(menuItem, 'parent')"
            [style.border-radius]="'var(--sidebar-nav-radius)'"
            [style.background-color]="navParentRowBg(menuItem)"
            (click)="
              onParentClick(menuItem, menuItem._key || itemKey(menuItem, i, 'main'))
            "
            [title]="!sidebarExpanded ? menuItem.label : undefined"
          >
            <i
              *ngIf="apiClassString(menuItem.icon)"
              class="shrink-0 w-5 h-5 text-[1.25rem] leading-5 flex items-center justify-center"
              [ngClass]="apiClassString(menuItem.icon)"
              [style.color]="
                isParentRowActive(menuItem)
                  ? 'var(--primary)'
                  : 'var(--foreground)'
              "
              [style.opacity]="isParentRowActive(menuItem) ? '1' : '0.6'"
            ></i>
            <span
              *ngIf="sidebarExpanded"
              class="flex-1 text-left !font-[500] !text-[rgb(33,38,51)]"
              [style.font-size]="'var(--text-sm)'"
              >{{ menuItem.label }}</span
            >
            <svg
              *ngIf="sidebarExpanded"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="h-4 w-4 shrink-0 transition-transform duration-200"
              [class.rotate-180]="
                isSectionOpen(menuItem._key || itemKey(menuItem, i, 'main'))
              "
              [ngClass]="{
                'text-primary': isParentRowActive(menuItem),
                'text-muted-foreground': !isParentRowActive(menuItem)
              }"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <div
            *ngIf="
              sidebarExpanded &&
              isSectionOpen(menuItem._key || itemKey(menuItem, i, 'main'))
            "
            class="ml-4 mt-1 space-y-1"
          >
            <ng-container
              *ngFor="let child of getChildItems(menuItem); trackBy: trackByChild"
            >
              <a
                *ngIf="!child.isExternalLink"
                [routerLink]="linkCommands(child)"
                [ngClass]="childRowNgClass(child)"
                class="sidebar-shell-child flex items-center w-full gap-2 px-3 py-2 transition-colors no-underline cursor-pointer"
                [style.border-radius]="'var(--sidebar-nav-radius)'"
                [style.font-size]="'var(--text-sm)'"
                [style.background-color]="childRowBg(child)"
              >
                <span
                  class="w-1.5 h-1.5 rounded-full shrink-0"
                  [style.background-color]="
                    isChildActive(child)
                      ? 'var(--primary)'
                      : 'var(--muted-foreground)'
                  "
                  [style.opacity]="isChildActive(child) ? '1' : '0.6'"
                ></span>
                <span>{{ child.label }}</span>
              </a>
              <button
                *ngIf="child.isExternalLink"
                type="button"
                [ngClass]="childRowNgClass(child)"
                class="sidebar-shell-child flex items-center w-full gap-2 px-3 py-2 transition-colors cursor-pointer border-0 text-left"
                [style.border-radius]="'var(--sidebar-nav-radius)'"
                [style.font-size]="'var(--text-sm)'"
                [style.background-color]="childRowBg(child)"
                (click)="navigateToItem(child)"
              >
                <span
                  class="w-1.5 h-1.5 rounded-full shrink-0"
                  [style.background-color]="
                    isChildActive(child)
                      ? 'var(--primary)'
                      : 'var(--muted-foreground)'
                  "
                  [style.opacity]="isChildActive(child) ? '1' : '0.6'"
                ></span>
                <span>{{ child.label }}</span>
              </button>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </nav>

  <nav
    *ngIf="footerNavItems.length"
    class="shrink-0 px-3 pt-2 pb-3 border-t border-border flex flex-col gap-1"
  >
    <ng-container *ngFor="let menuItem of footerNavItems; let i = index">
      <ng-container
        *ngIf="
          apiClassString(menuItem.classs) !== 'navigation-header' ||
          isParent(menuItem)
        "
      >
        <button
          *ngIf="isLeaf(menuItem)"
          type="button"
          class="sidebar-shell-nav-btn flex items-center w-full py-2.5 transition-colors group border-0 cursor-pointer text-left"
          [ngClass]="sidebarNavButtonNgClass(menuItem, 'leaf')"
          [style.border-radius]="'var(--sidebar-nav-radius)'"
          [style.background-color]="navLeafRowBg(menuItem)"
          (click)="navigateToItem(menuItem)"
          [title]="!sidebarExpanded ? menuItem.label : undefined"
        >
          <i
            *ngIf="apiClassString(menuItem.icon)"
            class="shrink-0 w-5 h-5 text-[1.25rem] leading-5 flex items-center justify-center"
            [ngClass]="apiClassString(menuItem.icon)"
            [style.color]="
              isLeafActive(menuItem) ? 'var(--primary)' : 'var(--foreground)'
            "
            [style.opacity]="isLeafActive(menuItem) ? '1' : '0.6'"
          ></i>
          <span class="!font-[500]"
            *ngIf="sidebarExpanded"
            [style.font-size]="'var(--text-sm)'"
            >{{ menuItem.label }}</span
          >
        </button>

        <div *ngIf="isParent(menuItem)">
          <button
            type="button"
            class="sidebar-shell-nav-btn flex items-center w-full py-2.5 transition-colors border-0 cursor-pointer text-left"
            [ngClass]="sidebarNavButtonNgClass(menuItem, 'parent')"
            [style.border-radius]="'var(--sidebar-nav-radius)'"
            [style.background-color]="navParentRowBg(menuItem)"
            (click)="
              onParentClick(
                menuItem,
                menuItem._key || itemKey(menuItem, i, 'footer')
              )
            "
            [title]="!sidebarExpanded ? menuItem.label : undefined"
          >
            <i
              *ngIf="apiClassString(menuItem.icon)"
              class="shrink-0 w-5 h-5 text-[1.25rem] leading-5 flex items-center justify-center"
              [ngClass]="apiClassString(menuItem.icon)"
              [style.color]="
                isParentRowActive(menuItem)
                  ? 'var(--primary)'
                  : 'var(--foreground)'
              "
              [style.opacity]="isParentRowActive(menuItem) ? '1' : '0.6'"
            ></i>
            <span class=""
              *ngIf="sidebarExpanded"
              class="flex-1 text-left !font-[500]"
              [style.font-size]="'var(--text-sm)'"
              >{{ menuItem.label }}</span
            >
            <svg
              *ngIf="sidebarExpanded"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="h-4 w-4 shrink-0 transition-transform duration-200"
              [class.rotate-180]="
                isSectionOpen(menuItem._key || itemKey(menuItem, i, 'footer'))
              "
              [ngClass]="{
                'text-primary': isParentRowActive(menuItem),
                'text-muted-foreground': !isParentRowActive(menuItem)
              }"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <div
            *ngIf="
              sidebarExpanded &&
              isSectionOpen(menuItem._key || itemKey(menuItem, i, 'footer'))
            "
            class="ml-4 mt-1 space-y-1"
          >
            <ng-container
              *ngFor="let child of getChildItems(menuItem); trackBy: trackByChild"
            >
              <a
                *ngIf="!child.isExternalLink"
                [routerLink]="linkCommands(child)"
                [ngClass]="childRowNgClass(child)"
                class="sidebar-shell-child flex items-center w-full gap-2 px-3 py-2 transition-colors no-underline cursor-pointer"
                [style.border-radius]="'var(--sidebar-nav-radius)'"
                [style.font-size]="'var(--text-sm)'"
                [style.background-color]="childRowBg(child)"
              >
                <span
                  class="w-1.5 h-1.5 rounded-full shrink-0"
                  [style.background-color]="
                    isChildActive(child)
                      ? 'var(--primary)'
                      : 'var(--muted-foreground)'
                  "
                  [style.opacity]="isChildActive(child) ? '1' : '0.6'"
                ></span>
                <span>{{ child.label }}</span>
              </a>
              <button
                *ngIf="child.isExternalLink"
                type="button"
                [ngClass]="childRowNgClass(child)"
                class="sidebar-shell-child flex items-center w-full gap-2 px-3 py-2 transition-colors cursor-pointer border-0 text-left"
                [style.border-radius]="'var(--sidebar-nav-radius)'"
                [style.font-size]="'var(--text-sm)'"
                [style.background-color]="childRowBg(child)"
                (click)="navigateToItem(child)"
              >
                <span
                  class="w-1.5 h-1.5 rounded-full shrink-0"
                  [style.background-color]="
                    isChildActive(child)
                      ? 'var(--primary)'
                      : 'var(--muted-foreground)'
                  "
                  [style.opacity]="isChildActive(child) ? '1' : '0.6'"
                ></span>
                <span>{{ child.label }}</span>
              </button>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </nav>

  <div
    *ngIf="!mainNavItems.length && !footerNavItems.length"
    class="flex-1 flex items-center justify-center px-3 py-8"
  >
    <p class="text-muted-foreground text-sm text-center">
      {{ '_Không có menu_' | translate }}
    </p>
  </div>
</div>
